'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@extern/ui/button';
import { AuthCard } from '@/app/(auth)/_partials/auth-card';
import { useSignIn } from '../_hooks/use-sign-in';
export function SignInForgotPassword() {
  const $ = _c(8);
  const {
    onSendResetCode,
    onGoBack
  } = useSignIn();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AuthCard.Header><AuthCard.Title>Forgot Password?</AuthCard.Title></AuthCard.Header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== onSendResetCode) {
    t1 = <Button className="w-full" onClick={() => onSendResetCode()} type="button">Reset your password via Email</Button>;
    $[1] = onSendResetCode;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onGoBack) {
    t2 = <Button appearance="outlined" className="w-full" color="info" onClick={onGoBack} type="button">Return</Button>;
    $[3] = onGoBack;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <AuthCard>{t0}<AuthCard.Content><div className="flex flex-col gap-6">{t1}{t2}</div></AuthCard.Content></AuthCard>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}